export default __webpack_public_path__ + "static/media/FreteGratis.13aa68f6.png";